// Contact Information
export const PHONE_NUMBER = '+18007378776';
export const PHONE_NUMBER_DISPLAY = '1-800-SERVPRO';

// Time Constants (in milliseconds)
export const TEN_MINUTES_IN_MS = 1000 * 60 * 10;
export const THREE_DAYS_IN_MS = 1000 * 60 * 60 * 72;
export const GTM_LOAD_TIMEOUT_MS = process.env.GATSBY_GTM_LOAD_TIMEOUT_MS;
export const POSTHOG_INGEST_API_KEY = process.env.GATSBY_POSTHOG_PROJECT_API_KEY;
export const POSTHOG_INGEST_HOST = process.env.GATSBY_POSTHOG_HOST;
export const NETLIFY_IMAGE_SITE_URL = process.env.URL || process.env.DEPLOY_PRIME_URL || '';

// Social Media URLs
export const SOCIAL_URL_LINKEDIN = 'https://www.linkedin.com/company/servpro-industries/';
export const SOCIAL_URL_TWITTER = 'https://twitter.com/servpro';
export const SOCIAL_URL_YOUTUBE = 'https://www.youtube.com/user/SERVPROCorporate';
export const SOCIAL_URL_FACEBOOK = 'https://www.facebook.com/SERVPRO';

// Form Configuration
export const FORMSPREE_TOKEN = 'xbjqblqv';
export const FORMSPREE_TOKEN_OWNERSHIP_FORM = 'xyyokdro';

// UI Text Constants
export const SITE_SEARCH_PLACEHOLDER = 'Search our site';
export const CHANGE_LOCATION = 'Update/change location';
export const YOUR_SELECTED_LOCATION = 'Your selected location is:';
export const YOUR_DETECTED_LOCATION = 'Your detected location is:';
/** Reserve box for primary location skeletons before geo/franchise resolve. */
export const LOCATION_PRIMARY_SKELETON_PLACEHOLDER = 'Springfield, MO';
export const LOCAL_CITY_LOCATION = 'Contact your local SERVPRO, serving:';
export const NATIONAL_CALL_CENTER_LOCATION = 'Talk to a representative now:';
export const NATIONAL_CALL_CENTER_DISPLAY = 'National Call Center';

/** Shown when a franchise is Temp Out of Service and the national number is listed instead of the local line. */
export const getTempOutOfServiceStatusMessage = (franchiseDisplayName: string): string => (
    `${franchiseDisplayName} is Temp Out of Service therefore the National Call Center number will be listed`
);

/** Temp out of service column copy on the franchise troubleshooting page (concise; live site may use {@link getTempOutOfServiceStatusMessage}). */
export const TEMP_OUT_OF_SERVICE_TROUBLESHOOTING_DISPLAY = 'Temp Out of Service, using National Call Center';

// Thresholds
export const AVERAGE_RATE_THRESHOLD = 4;

// Data Limits
export const MAX_TESTIMONIALS_PER_CATEGORY = 9;
export const MAX_FRANCHISES_PER_BATCH = 60;
/** `FranchiseTestimonialsSlider` does not render below this count (see component). */
export const MIN_TESTIMONIALS_FOR_SLIDER = 3;

export const URLS = {
    STATIC: {
    // The real production URL
        PRODUCTION_URL: 'https://www.servpro.com',

        // The real staging URL
        STAGING_URL: 'https://servpro-drafts.netlify.app',

        // All of the URLs we could receive for redirects, etc. // process.env.TEST_INSTANCE_DEPLOYED_SITE_URL, - need to make sure this transfers correctly

        BASE_SITE_URLS: [
            process.env.ID_SCOPED_DEPLOY_URL,
            process.env.CANONICAL_URL,
            'https://www.servpro.com',
            'https://servpro.com',
            'http://www.servpro.com',
            'http://servpro.com',
            'http://localhost:8000',
            'http://localhost:9000',
            process.env.LOCAL_GATSBY_URL,
            process.env.LOCAL_PROXY_URL,
            process.env.AGNOSTIC_MAIN_BRANCH_URL,
        ].filter(Boolean) as string[],
    },
    SERVER_SIDE: {
        ID_SCOPED_DEPLOY_URL: process.env.ID_SCOPED_DEPLOY_URL || '',
        CANONICAL_URL: process.env.CANONICAL_URL || '',
        AGNOSTIC_MAIN_BRANCH_URL: process.env.AGNOSTIC_MAIN_BRANCH_URL || '',
    },
    CLIENT_SIDE: {
    // No ID_SCOPED_DEPLOY_URL for client-side rendering - use relative paths for fetch.
        CANONICAL_URL: process.env.CANONICAL_URL || '',
        AGNOSTIC_MAIN_BRANCH_URL: process.env.AGNOSTIC_MAIN_BRANCH_URL || '',
    },
};

export const POSTHOG = {
    CLIENT_SIDE: {
        POSTHOG_PROJECT_API_KEY: process.env.POSTHOG_PROJECT_API_KEY || '',
        SHOULD_RUN_POSTHOG: process.env.SHOULD_RUN_POSTHOG || '',
    },
    SERVER_SIDE: {
        POSTHOG_PERSONAL_API_KEY: process.env.POSTHOG_PERSONAL_API_KEY || '',
        POSTHOG_HOST: process.env.POSTHOG_HOST || '',
        POSTHOG_PROJECT_ID: process.env.POSTHOG_PROJECT_ID || '',
    },
};

export const ENVIRONMENT = {
    IS_DRAFTS: process.env.IS_DRAFTS === 'true',
    IS_SERVPRO_COM_TRUE_PRODUCTION: process.env.IS_SERVPRO_COM_TRUE_PRODUCTION === 'true',
    IS_NOT_DEV: process.env.IS_NOT_DEV === 'true',
    IS_DEV: process.env.IS_DEV === 'true',
    IS_RUNNING_ON_NETLIFY: process.env.IS_RUNNING_ON_NETLIFY === 'true',
    IS_FUNCTION_CONTEXT: process.env.IS_FUNCTION_CONTEXT === 'true',
};

export const CONTENTSTACK = {
    SERVER_SIDE: {
        CONTENTSTACK_API_KEY: process.env.CONTENTSTACK_API_KEY || '',
        CONTENTSTACK_DELIVERY_TOKEN: process.env.CONTENTSTACK_DELIVERY_TOKEN || '',
        CONTENTSTACK_MANAGEMENT_TOKEN:
      process.env.CONTENTSTACK_MANAGEMENT_TOKEN || '',
        CONTENTSTACK_PREVIEW_TOKEN: process.env.CONTENTSTACK_PREVIEW_TOKEN || '',
        CONTENTSTACK_ENVIRONMENT: process.env.CONTENTSTACK_ENVIRONMENT || '',
        CONTENTSTACK_BRANCH: process.env.CONTENTSTACK_BRANCH || 'main',
    },
};

export const GEO = {
    SERVER_SIDE: {
        ARCGIS_BUILDS_KEY: process.env.ARCGIS_BUILDS_KEY || '', // Original key
        ARCGIS_LIVE_ENDPOINTS_KEY: process.env.ARCGIS_LIVE_ENDPOINTS_KEY || '',
        GOOGLE_EARTH_KEY: process.env.GOOGLE_EARTH_KEY || '',
        GOOGLEAPI_KEY: process.env.GOOGLEAPI_KEY || '',
    },
};

export const EMAIL = {
    SERVER_SIDE: {
        EMAIL_SMTP_HOST: process.env.EMAIL_SMTP_HOST || '',
        EMAIL_SMTP_PORT_NUMBER: process.env.EMAIL_SMTP_PORT_NUMBER || '',
        EMAIL_SMTP_USERNAME: process.env.EMAIL_SMTP_USERNAME || '',
        EMAIL_SMTP_PASSWORD: process.env.EMAIL_SMTP_PASSWORD || '',
    },
};

export const CAREER = {
    SERVER_SIDE: {
        CAREERPLUG_API_CLIENT_ID: process.env.CAREERPLUG_API_CLIENT_ID || '',
        CAREERPLUG_API_CLIENT_SECRET:
      process.env.CAREERPLUG_API_CLIENT_SECRET || '',
    },
};

export const ALGOLIA = {
    SERVER_SIDE: {
        ALGOLIA_APP_ID: process.env.ALGOLIA_APP_ID || '',
        ALGOLIA_ADMIN_API_KEY: process.env.ALGOLIA_ADMIN_API_KEY || '',
    },
};

export const BUILD_PROXY = {
    SERVER_SIDE: {
        PROXY_AUTH: process.env.PROXY_AUTH || '',
    },
};

export const SCHEMA_ORG = {
    PHONE_NUMBER: '+1-800-737-8776',
    BASE_URL: URLS.CLIENT_SIDE.CANONICAL_URL || '',
    ORGANIZATION_ID: `${URLS.CLIENT_SIDE.CANONICAL_URL}#organization`,
    WEBSITE_ID: `${URLS.CLIENT_SIDE.CANONICAL_URL}#website`,
    LOGO_URL: [
        ENVIRONMENT.IS_RUNNING_ON_NETLIFY
            ? `${URLS.CLIENT_SIDE.CANONICAL_URL}/dcs-images`
            : 'https://images.contentstack.io',
        '/v3/assets/blt0a0cb058815d4d96/blt9af1c0e2eaba012a/servpro_vehicle.jpeg?width=1200&auto=webp',
    ].join(''),
};

export const NETLIFY = {
    SERVER_SIDE: {
        NETLIFY_SITE_ID: process.env.NETLIFY_SITE_ID || '',
        NETLIFY_API_TOKEN: process.env.NETLIFY_API_TOKEN || '',
    },
};

export const INVOCA = {
    CLIENT_SIDE: {
        INVOCA_NETWORK_ID: process.env.INVOCA_NETWORK_ID || '',
        INVOCA_TAG_ID: process.env.INVOCA_TAG_ID || '',
    },
    STATIC: {
        INVOCA_TAG_URL:
      `https://solutions.invocacdn.com/js/networks/${process.env.INVOCA_NETWORK_ID}/${process.env.INVOCA_TAG_ID}/tag-live.js` as const,
    },
};
